import { defineMessage } from 'services/localization';

export const messages = {
    selectOrganisation: defineMessage('select_organisation'),
    selectWorkflows: defineMessage('select_workflows'),
    toCompanyFieldLabel: defineMessage('copy_workflows_to_organisation'),
};
